import { ThemeProvider } from './theme/ThemeProvider';
import { VimProvider, VimStatusBar, VimKeyboardHandler } from './vim';
import { KeystrokeVisualizer } from './components/KeystrokeVisualizer';
import { GlassmorphismBackground } from './components/GlassmorphismBackground';
import { AuroraBackground } from './components/AuroraBackground';
import { NeoBrutalismBackground } from './components/NeoBrutalismBackground';
import { DotMatrixBackground } from './components/DotMatrixBackground';
import { RedSpriteWalker } from './components/RedSpriteWalker';
import Home from './routes/Home';
import './styles/glassmorphism.css';
import './styles/aurora.css';
import './styles/8bit-enhanced.css';
import './styles/vector-led.css';
import './styles/retro-terminal.css';
import './styles/neomorphism.css';
import './styles/flat20.css';
import './styles/flat-design.css';
import './styles/minimalism.css';
import './styles/neo-brutalism.css';
import './styles/modern-minimal.css';
import './styles/dot-matrix.css';
import './styles/vim.css';
import './styles/keystroke-visualizer.css';

function App() {
  return (
    <ThemeProvider>
      <VimProvider>
        <VimKeyboardHandler />
        <GlassmorphismBackground />
        <AuroraBackground />
        <NeoBrutalismBackground />
        <DotMatrixBackground />
        <Home />
        <RedSpriteWalker />
        <VimStatusBar />
        <KeystrokeVisualizer />
      </VimProvider>
    </ThemeProvider>
  );
}

export default App;
